import { Action } from '@/store/workflow/actions'
import { Gateway, Process } from '@/store/workflow/types'
import { each, filter, isInteger, IterateeShorthand } from 'lodash'
import Vue, { VNode } from 'vue'
import { ScopedSlotReturnValue } from 'vue/types/vnode'

export default Vue.extend({
  computed: {
    filters() {
      const filters: IterateeShorthand<Gateway> = {}

      // select by task variable
      if (this.name) {
        filters.activity_id = this.name
      }

      // select by process business key
      if (typeof this.inProcess === 'string') {
        filters.business_key = this.inProcess
      } else if (typeof this.inProcess === 'object') {
        filters.process_instance_id = this.inProcess.id
      }

      // select by case variable
      filters.case_id = this.case ? this.case : this.$store.getters.currentCaseId

      return filters
    },
    enteredGateways(): Gateway[] {
      const gateways: Gateway[] = this.$store.getters['workflow/enteredGateways']
      return filter(gateways, this.filters)
    },
    passedGateways(): Gateway[] {
      const gateways: Gateway[] = this.$store.getters['workflow/passedGateways']
      return filter(gateways, this.filters)
    },
  },
  inject: {
    process: {
      default: null,
    },
  },
  props: {
    case: {
      type: String,
    },
    inProcess: {
      type: [String, Object as () => Process],
      default(): Process | null {
        return (this as any).process
      },
    },
    name: {
      type: String,
    },
    tag: {
      default: 'div',
      type: String,
    },
  },
  render(): VNode {
    const Tag = this.tag
    const passedGateways = this.passedGateways

    let content: ScopedSlotReturnValue = []

    // for entered gateways
    if (this.enteredGateways.length > 0 && this.$scopedSlots.entered) {
      const enteredSlot = this.$scopedSlots.entered
      content = content.concat(
        this.enteredGateways.map(gateway =>
          enteredSlot({
            gateway,
          })
        )
      )

      content = content.concat(
        this.enteredGateways.map(gateway => (
          <portal to="waiting-gateways">
            <div class="gateway">
              {gateway.business_key}/{gateway.activity_id}
            </div>
          </portal>
        ))
      )
    }

    // for passed gateways
    if (this.passedGateways.length > 0 && this.$scopedSlots.passed) {
      const passedSlot = this.$scopedSlots.passed
      content = content.concat(this.passedGateways.map(gateway => passedSlot({ gateway })))
    }

    // if no due or done task was found
    if (this.passedGateways.length + this.enteredGateways.length === 0 && this.$slots.else) {
      content = content.concat(this.$slots.else)
    }

    return <Tag {...this.$attrs}>{content}</Tag>
  },
})
